/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */

export interface BarsProps {
  isMobile?: boolean;
  onClick?: () => void;
}

export const Bars = ({ isMobile = true, onClick }: BarsProps) => {

  if (isMobile) {
    return (
      <svg onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 12H20M4 18H20M4 6H20" stroke="#111111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    );
  } 
  return (
    <svg onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 12H20M4 18H20M4 6H20" stroke="#111111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

  );
  
};
